<template>
    <div class="chartFormNewRoot">
      <div class="changeBlock">
        <div class="changeLine">
          <div class="changeBtn" @click="changeOneLever(1)" :style="{borderBottom: currentIndex===1?'3px solid #FEAE00':'',color: currentIndex===1?'#1c180d':'',fontWeight:currentIndex===1?600:400}">
            <span>Monthly Subscription</span>
            <span class="offItem">SAVE 10%</span>
          </div>
          <div  class="changeBtn" @click="changeOneLever(2)"  :style="{borderBottom: currentIndex===2?'3px solid #FEAE00':'',color: currentIndex===2?'#1c180d':'',fontWeight:currentIndex===2?600:400}">
            
            <span>One-Time Purchase</span>
            <span class="offItem">SAVE 28%</span>
          </div>
        </div>
      </div>
      <div class="btnBlock">
        <div class="changeBlock" v-if="currentIndex !=1">
          <div class="btnNewLine">
              <div class="rightBtn" @click="changeTwoLever(1)"   :style="{background:secondIndex===1?'#FEAE00':'#fff',color:secondIndex===1?'#1c180d':'#757575',fontWeight:secondIndex===1?600:400}">1 Month</div>
              <div class="leftBtn" @click="changeTwoLever(2)"  :style="{background:secondIndex===2?'#FEAE00':'#fff',color:secondIndex===2?'#1c180d':'#757575',fontWeight:secondIndex===2?600:400}">
                  <span class="leftBtnText">1 Year</span> 
                  <span class="offBtn">SAVE 28%</span>
              </div>
          </div>
        </div>
      
        <div  class="formNewBox">
          <div @click="changeSubIndex(index)" :style="{display:index==0?'none':''}" :class="{'formOfActive':chooseCurrentIndex===index,formItem:true}" v-for="(item,index) in currentCharge " :key="index" >
            <div class="popularBlock" v-if="index==4"> <span   class="popularText"  > Most Popular</span></div>
            <div class="firstItem">
              <div class="titleblock">
                <span :class="`titleText badge badge-${item.className}`">{{item.title}}</span>
                <span  :class="{'bestOfActive':chooseCurrentIndex===index,bestText:true}"  v-if="index==5"> Best Value</span>
              </div>
              <div class="amountText">{{`$${item.monthAmount}`}} <span class="unitText">{{item.unit}}</span></div>
              <div class="freeBlock" :ref="`freeBlock_${index}`">
                <!-- <div class="freeText">{{item.infor1}}</div> -->
                <div class="freeAmountText" >{{item.infor2}}</div>
              </div>
            </div>
            <div class="twoItem"  :ref="`threeItem_${index}`">
              <div class="oneInfro">{{item.infor3}}</div>
              <div class="twoInfor">{{item.infor4}}</div>
            </div>
            <div class="threeItem"  :ref="`threeItem_${index}`">{{item.infor5}}</div>
            <div class="fourItem"  @click.stop="handleAddOrder('btnStatus2',index,item,'emptyLever')">{{item.btnName}}</div>
            <div class="fiveItem" :ref="`itemLine_${index}`">
              <div class="itemLine" v-for="(infor, key) in chargInfor[index]" :key="key" >
                <i class="el-icon-success circleItem"></i>
                <div class="textBlock">
                  <div class="fiveText">{{infor.title}}
                    
                    <div style="display:inline-block;vertical-align: sub;" v-if="infor.infor">
                      <el-tooltip :content="infor.infor" class="toolItem" effect="dark" placement="right-start" popper-class="top-tip" >
                          <span class="target-element">
                                  <svg xmlns="http://www.w3.org/2000/svg" class="svgItem" width="12" height="12" viewBox="0 0 16 16" fill="none">
                                      <path d="M14.9941 8C14.9941 4.13401 11.8601 1 7.99414 1C4.12815 0.999998 0.994142 4.134 0.994141 8C0.994138 11.866 4.12815 15 7.99414 15C11.8601 15 14.9941 11.866 14.9941 8ZM5.80249 6.6315C5.80249 5.42262 6.78511 4.44 7.99399 4.44C9.20288 4.44 10.1855 5.42262 10.1855 6.6315C10.1855 7.60163 9.4429 8.35248 8.701 8.65455C8.58005 8.70488 8.49403 8.82451 8.49403 8.97008V9.7675H7.49403V8.97008C7.49403 8.41041 7.83289 7.931 8.32041 7.7298L8.32296 7.72875C8.81772 7.52775 9.1855 7.07185 9.1855 6.6315C9.1855 5.9749 8.65059 5.44 7.99399 5.44C7.33739 5.44 6.80249 5.9749 6.80249 6.6315H5.80249ZM7.46673 11.1734C7.46673 10.8823 7.70277 10.6462 7.99395 10.6462C8.28513 10.6462 8.52117 10.8823 8.52117 11.1734C8.52117 11.4646 8.28513 11.7007 7.99395 11.7007C7.70277 11.7007 7.46673 11.4646 7.46673 11.1734Z" fill="#808080"/>
                                  </svg>
                              </span>
                      </el-tooltip>
                    </div>
                  </div> 
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chargTool">
        <div class="payLine">
            <div class="payItem" v-for="(item,index) in payList" :key="index">
                <img  class="payIcon"  :src="require(`../../assets/img/main/pay/${item.icon}`)" alt="">
                <span class="payText">{{ item.name }}</span>
            </div>
        </div>
        <div class="payLine">
            <div class="payItem" v-for="(item,index) in 5" :key="index">
                <img  class="toolIcon"  :src="require(`../../assets/img/newHome/tool${item}.png`)" alt="">
            </div>
        </div>
        <div class="textLine">
          <div class="textItem">* <span  class="textItem" >For more information please check our </span> <a :href="linkObj.refundPolicy" target="_blank"  class="textItem" style="color: #FEAE00;">Refund Policy</a> </div>
        </div>

      </div>
      <div class="serviceBox">
        <ServiceBlock :currentAmount="packageAmount"  :defaultNum="setDefault" :serviceLevel="[]"  :serviceNum="currentService" @sendMessage="handleMessageChange"></ServiceBlock>

      </div>
      <div class="lastSubLin">
        <div class="subBtn" @click.stop="handleSbuOrder">Subscribe Now</div>
        <div class="defBtn" @click="defaultSet">Default</div>
      </div>
    </div>
</template>
<script>
import { nextTick } from 'vue'
import {judgeLogin} from './loading'

 import ServiceBlock from './serviceBlock.vue'
  export default {
    components:{ServiceBlock},
    props:['currentStatus','toLink'],
    data() {
      return {
        imgObj:{
            mainLogo:require("../../assets/img/main/mainLogo.png"),
            chooseIcon:require("../../assets/img/main/chooseIcon.png"),
            getOff:require("../../assets/img/main/getOff.png"),
        },
         payList:[
            {name:'Card',icon:'card.png'},
            {name:'Apple Pay',icon:'applePay.png'},
            {name:'Google Pay',icon:'googlePay.png'},
            {name:'Alipay (one-time payments only)',icon:'alipay.png'},
            {name:'klarna (one-time payments only)',icon:'klarna.png'},
            // {name:'WeChat(one-time payments only)',icon:'wechat.png'},
            {name:'Link',icon:'Link1.png'},
            {name:'Affirm',icon:'affirm.png'},
            {name:'Cash App Pay',icon:'cashAppPay.png'},
            {name:'Amazon Pay',icon:'amazonPay.png'},
            {name:'Bancontact',icon:'Bancontact.png'},
        ],
        linkObj:{
            privacyNotice:"https://paperspotlight.com/paper-policy/privacyNotice.html",
            termsOfUse:"https://paperspotlight.com/paper-policy/termsOfUse.html",
            cookiePolicy:"https://paperspotlight.com/paper-policy/cookiePolicy.html",
            refundPolicy:"https://paperspotlight.com/paper-policy/refundPolicy.html",
            disclaimer:"https://paperspotlight.com/paper-policy/disclaimer.html",
        },
        currentService:[1],
        currentIndex:1, //一级
        secondIndex:2,//二级
        chooseSubIndex:1,
        chooseMonthIndex:1,
        chooseYearIndex:1,
        chooseCurrentIndex:1,

        btnStatus:[true,true,true,true,true,true],
        btnStatus2:[true,true,true,true,true,true],
        receiveMessage: '',
        serverLever:[2,2,2,2],
        defauleWeight:[2,2,2,2],
        setDefault:2233,
        packageAmount:62.1 ,
        currentCharge:[],
        chargeForm:[
          [
            {title:'test',className:'test', monthAmount:'62.1',unit:'',perAmount:'62.1', infor1:'',infor2:'$69',infor3:'Billed monthly',infor4:'Auto-renews • Cancel anytime',infor5:'Save $82.80 per year (10%)',btnName:'Subscribe Monthly',link:''},
            {title:'Basic',className:'Basic', monthAmount:'62.1',unit:'',perAmount:'62.1',infor1:'',infor2:'$69',infor3:'Billed monthly',infor4:'Auto-renews • Cancel anytime',infor5:'Save $82.80 per year (10%)',btnName:'Subscribe Monthly',link:''},
            {title:'Basic++',className:'Basic-plus', monthAmount:'108',unit:'',perAmount:'108',infor1:'',infor2:'$120',infor3:'Billed monthly',infor4:'Auto-renews • Cancel anytime',infor5:'Save $144.00 per year (10%)',btnName:'Subscribe Monthly',link:''},
            {title:'Std',className:'Std', monthAmount:'202.5',unit:'',perAmount:'202.5',infor1:'',infor2:'$225',infor3:'Billed monthly',infor4:'Auto-renews • Cancel anytime',infor5:'Save $270.00 per year (10%)',btnName:'Subscribe Monthly',link:''},
            {title:'Std++',className:'Std-plus', monthAmount:'292.5',unit:'',perAmount:'292.5',infor1:'',infor2:'$325',infor3:'Billed monthly',infor4:'Auto-renews • Cancel anytime',infor5:'Save $390.00 per year (10%)',btnName:'Subscribe Monthly',link:''},
            {title:'Pro',className:'Pro', monthAmount:'450',unit:'',perAmount:'450',infor1:'',infor2:'$500',infor3:'Billed monthly',infor4:'Auto-renews • Cancel anytime',infor5:'Save $600.00 per year (10%)',btnName:'Subscribe Monthly',link:''},
          ],
          [
            {title:'test',className:'test', monthAmount:'69',unit:'',perAmount:'69',infor1:'',infor2:'',infor3:'One-time payment • 1 month campaigns',infor4:'No auto-renewal',infor5:'',btnName:'Buy 1 Month',link:''},
            {title:'Basic',className:'Basic', monthAmount:'69',unit:'',perAmount:'69',infor1:'',infor2:'',infor3:'One-time payment • 1 month campaigns',infor4:'No auto-renewal',infor5:'',btnName:'Buy 1 Month',link:''},
            {title:'Basic++',className:'Basic-plus', monthAmount:'120',unit:'',perAmount:'120',infor1:'',infor2:'',infor3:'One-time payment • 1 month campaigns',infor4:'No auto-renewal',infor5:'',btnName:'Buy 1 Month',link:''},
            {title:'Std',className:'Std', monthAmount:'225',unit:'',perAmount:'225',infor1:'',infor2:'',infor3:'One-time payment • 1 month campaigns',infor4:'No auto-renewal',infor5:'',btnName:'Buy 1 Month',link:''},
            {title:'Std++',className:'Std-plus',monthAmount:'325',unit:'',perAmount:'325',infor1:'',infor2:'',infor3:'One-time payment • 1 month campaigns',infor4:'No auto-renewal',infor5:'',btnName:'Buy 1 Month',link:''},
            {title:'Pro',className:'Pro',monthAmount:'500',unit:'',perAmount:'500',infor1:'',infor2:'',infor3:'One-time payment • 1 month campaigns',infor4:'No auto-renewal',infor5:'',btnName:'Buy 1 Month',link:''},
          ],
          [
            {title:'test',className:'test', monthAmount:'49.68',unit:'/ monthly',perAmount:'49.68',infor1:'$49.68 / mo equivalent',infor2:'$69',infor3:'One-time payment • 12 months campaigns',infor4:'No auto-renewal',infor5:'Save $231.84 (28%)',btnName:'Buy 1 Year',link:''},
            {title:'Basic',className:'Basic', monthAmount:'49.68',unit:'/ monthly',perAmount:'49.68',infor1:'$49.68 / mo equivalent',infor2:'$69',infor3:'One-time payment • 12 months campaigns',infor4:'No auto-renewal',infor5:'Save $231.84 (28%)',btnName:'Buy 1 Year',link:''},
            {title:'Basic++',className:'Basic-plus', monthAmount:'86.4',unit:'/ monthly',perAmount:'86.4',infor1:'$86.40 / mo equivalent',infor2:'$120',infor3:'One-time payment • 12 months campaigns',infor4:'No auto-renewal',infor5:'Save $403.20 (28%)',btnName:'Buy 1 Year',link:''},
            {title:'Std',className:'Std', monthAmount:'162',unit:'/ monthly',perAmount:'162',infor1:'$162.00 / mo equivalent',infor2:'$225',infor3:'One-time payment • 12 months campaigns',infor4:'No auto-renewal',infor5:'Save $756.00 (28%)',btnName:'Buy 1 Year',link:''},
            {title:'Std++',className:'Std-plus',monthAmount:'234',unit:'/ monthly',perAmount:'234',infor1:'$234.00 / mo equivalent',infor2:'$325',infor3:'One-time payment • 12 months campaigns',infor4:'No auto-renewal',infor5:'Save $1092.00 (28%)',btnName:'Buy 1 Year',link:''},
            {title:'Pro',className:'Pro',monthAmount:'360',unit:'/ monthly',perAmount:'360',infor1:'$360.00 / mo equivalent',infor2:'$500',infor3:'One-time payment • 12 months campaigns',infor4:'No auto-renewal',infor5:'Save $1680.00 (28%)',btnName:'Buy 1 Year',link:''},
          ],
        ],
        chargInfor:[
          [],
          [
            {title:'Multi-channel campaigns (RG/LinkedIn/Email/LLMOps)',infor:'Channel-native dissemination packages are produced and distributed across ResearchGate, LinkedIn, email, and AI/LLM Platforms.'},
            {title:'Structured metadata (LLMOps/SEO)',infor:'Machine-readable metadata (structured fields, and applicable schema) is generated to improve indexing accuracy in search and LLM platforms without keyword stuffing.'}
          ],
          [
            {title:'Include all Basic Plan features',infor:''},
            {title:'Performance report',infor:'A weekly/monthly performance brief reports observable impressions by paper and channel, together with a defined action plan for the next reporting cycle.'},
            {title:'Google Scholar tracking',infor:'Google Scholar citation counts and profile/publication indicators are daily monitored, data will be shared with performance report.'},
            {title:'Manual Email → Automated Email',infor:'Manual outreach workflows are converted into automated email sequences, routing, and delivery tracking.'},
          ],
          [
            {title:'Include all Basic++ Plan features',infor:''},
            {title:'1v1 Human Support',infor:'Dedicated one-to-one support provides guided setup, issue resolution, and strategy adjustments.'},
            {title:'Campaign share controls (per-paper %)',infor:'Percentage-based impression allocation controls enforce the distribution of total campaign volume across selected papers according to user-defined shares.'},
            {title:'24-hour auto optimization',infor:'Dissemination parameters (channel weighting, timing, and approved content variants) are automatically re-optimized on a 24-hour cadence based on observed engagement signals, with change logging.'},
          ],
          [
            {title:'Include all Std Plan features',infor:''},
            {title:'Lifecycle campaigns',infor:'Milestone-based dissemination schedules are executed around publication lifecycle and channel timing.'},
            {title:'Research events and Emerging Topics',infor:'Based on the research evetns (conferences and events) and Clarivate research horizon navigator Emerging Topics to auto adjust the campaigns.'},
            {title:'Deep custom strategy',infor:'A tailored strategy for dissemination plan.'},
          ],
          [
            {title:'Include all Std++ Plan features',infor:''},
            {title:'Trend forecasting (beta)',infor:'Forecasts of attention metrics over 7/30/90-day horizons are produced with confidence levels and are not presented as guaranteed citation outcomes.'},
            {title:'Likely-to-submit intent prioritization (beta)',infor:'Public activity signals are modeled to prioritize researchers with higher near-term manuscript submission likelihood for outreach sequencing, without use of private data.'},
          ],
        ]
      }
    },
    watch:{
    },
    created(){
        window.addEventListener('resize', this.handleResize);
    },
    deactivated(){
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      handleResize(){
        this.$nextTick(() => {
            this.equalizeItemLineHeights('.freeBlock');
            this.equalizeItemLineHeights('.twoItem');
            this.equalizeItemLineHeights('.threeItem');
            this.equalizeItemLineHeights('.fiveItem');
          });
      },
        //  切换一级
        changeOneLever( index){
          this.currentIndex= index
          if(index===1){
            this.currentCharge = [...this.chargeForm[this.currentIndex-1]]
             this.chooseCurrentIndex =  this.chooseSubIndex
          }else{
            this.currentCharge = [...this.chargeForm[this.secondIndex]]
             if(this.secondIndex==1){
              this.chooseCurrentIndex = this.chooseMonthIndex
            }else{
              this.chooseCurrentIndex = this.chooseYearIndex
            }
          }
           this.currentService = []
            this.currentService[0] = this.chooseCurrentIndex
            this.receiveMessage= ''
            this.serverLever = [...this.defauleWeight]
            this.packageAmount =  this.currentCharge[this.chooseCurrentIndex].perAmount
         this.handleResize()
        },
        //切换二级
        changeTwoLever(index){
          this.secondIndex = index
          this.currentCharge = [...this.chargeForm[this.secondIndex]]
          if(this.secondIndex==1){
              this.chooseCurrentIndex = this.chooseMonthIndex
            }else{
              this.chooseCurrentIndex = this.chooseYearIndex
            }

             this.currentService = []
            this.currentService[0] = this.chooseCurrentIndex
            this.receiveMessage= ''
            this.serverLever = [...this.defauleWeight]
            this.packageAmount =  this.currentCharge[this.chooseCurrentIndex].perAmount

            this.handleResize()
        },
        // 获取list高度
        equalizeItemLineHeights(className) {
          // 获取所有 .itemLine 元素fiveItem
          const itemLines = document.querySelectorAll(className);
          
          if (itemLines.length === 0) return;
          
          // 重置高度并计算最大高度
          let maxHeight = 0;
          itemLines.forEach(el => {
            el.style.height = 'auto'; // 重置为自动高度
            const height = el.offsetHeight || el.clientHeight;
            maxHeight = Math.max(maxHeight, height);
          });
          console.log('maxHeight',maxHeight)
          
          // 设置统一高度
          itemLines.forEach(el => {
            el.style.height = `${maxHeight}px`;
          });
        },
        handleMessageChange(message,leverArr){
            this.receiveMessage = message
            if(leverArr.length==4){
              let sum = 0;
              for (let i = 0; i < leverArr.length; i++) {
                  sum += leverArr[i];
              }
              if(sum==8){
                this.serverLever = [...leverArr]

              }else{
              this.serverLever = [...this.defauleWeight]

              }
            }else{
              this.serverLever = [...this.defauleWeight]
            }
           
            console.log('this.receiveMessage',this.receiveMessage,  this.serverLever)
        },
        changeSubIndex(index){
          console.log('changeSubIndex')
          if(this.currentIndex==1){
            this.chooseSubIndex = index
          }else{
            if(this.secondIndex==1){
              this.chooseMonthIndex = index
            }else{
              this.chooseYearIndex = index
            }
          }
          this.chooseCurrentIndex = index
          
          console.log(' this.chooseCurrentIndex ', this.chooseCurrentIndex )

            this.currentService = []
            this.currentService[0] = index
            this.receiveMessage= ''
            this.serverLever = [...this.defauleWeight]
            this.packageAmount =  this.currentCharge[this.chooseCurrentIndex].perAmount
     
        },
        changeMonthIndex(index){
            this.currentService = []
            this.currentService[0] = index+10
            this.receiveMessage= ''
            this.serverLever = this.defauleWeight
            this.packageAmount =  this.currentCharge[this.chooseCurrentIndex].perAmount
      
        },
        handleAddOrder(status,index,item,text){
          // console.log(index,item)
          // return
          const isLogin = judgeLogin()
          let userinfor = JSON.parse(localStorage.getItem('userInfo'))
          if(isLogin && userinfor&&item.link){
            console.log(  this.serverLever)
            let param = {}
            if(text){
              param = {
                4001: this.defauleWeight[0],
                4002:  this.defauleWeight[1],
                4003: this.defauleWeight[2],
                4004:  this.defauleWeight[3],

            }
            }else{
              param = {
                4001:  this.serverLever[0],
                4002:  this.serverLever[1],
                4003:  this.serverLever[2],
                4004:  this.serverLever[3],

              }
            }
            
            this.$https('savaPackageServerLevel',param).then(res => {
              console.log(res)
            }).catch(err=>{
            })

            let link = `${item.link}?client_reference_id=${userinfor.userId}`
            window.open(link, '_blank')
            setTimeout(() => {
              this.$emit('confirmPay')

            },500)
          }else{
            if(this.toLink){
              this.$emit('confirmPay')
              this.$router.push(this.toLink); 
            }else{
              this.$router.push('/login'); 
            }
          }
      
        },
        handleSbuOrder(){
            if(this.receiveMessage){
              this.$message.warning(this.receiveMessage);
              return
            }
            let index = 1
            let item = {}
            index = this.chooseCurrentIndex
            if(this.currentIndex==1){
              item = this.chargeForm[this.currentIndex-1][this.chooseCurrentIndex]
            }else{
              item = this.chargeForm[this.secondIndex][this.chooseCurrentIndex]
            }
            console.log('btnStatus2',index,item)
            this.handleAddOrder('btnStatus2',index,item)
        },
        //恢复到默认
        defaultSet(){
            this.setDefault = new Date().getTime();
            this.receiveMessage= ''
            this.serverLever = [...this.defauleWeight]

        }
    },
    mounted: function() {

      let userData = JSON.parse(localStorage.getItem('userData'))
      console.log('userData',userData,)
      if(userData&&userData.weight&&userData.weight.length){
        this.serverLever= [...userData.weight]
        this.defauleWeight= [...userData.weight]
      }
     
      
    
      for(let i in this.chargeForm[0]){
         this.chargeForm[0][i].link = this.$t('tableModule.packageObj')[i].link
      }
      for(let i in this.chargeForm[1]){
         this.chargeForm[1][i].link = this.$t('tableModule.packageObj2')[i].link
      }
      for(let i in this.chargeForm[2]){
         this.chargeForm[2][i].link = this.$t('tableModule.packageObj3')[i].link
      }
      this.currentCharge = [...this.chargeForm[this.currentIndex-1]]

      this.packageAmount =  this.currentCharge[this.chooseCurrentIndex].perAmount

      this.changeMonthIndex(4)
      this.changeSubIndex(4)
      this.handleResize()

    },
  }
</script>
<style  lang="scss" >
.chartFormNewRoot{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 48px;
  *{
    font-family: PingFang SC !important;
  }
   .badge {
            display: inline-block !important;
            width: 60px  !important; 
            padding: 4px 0;
            text-align: center  !important;
            font-weight: 900  !important;
            font-size: 12px  !important;
            border: 2px solid #000  !important;
            text-transform: uppercase  !important;
            line-height: normal;
        }

  .badge-Basic { background: #EEE  !important; color: #888  !important; }
  .badge-Basic-plus { background: #FFF  !important; color: #000  !important; }
  .badge-Std { background: #FFF  !important; color: #feae00  !important; }
  .badge-Std-plus { background: #feae00  !important; color: #fff  !important; }
  .badge-Pro { background: #000  !important; color: #feae00  !important; }
  .btnBlock{
     width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
  }
  .changeBlock{
    display: flex;
    justify-content: center;
    .changeLine{
      display: flex;
      justify-content: center;
      gap: 36px;
      border-bottom: 1px solid #00000033;
      .changeBtn{
        cursor: pointer;
        color: #757575;
        padding-bottom: 12px;
        font-size: 20px;
        display: flex;
        align-items: center;
        gap: 4px;
        .offItem{
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2px 8px;
          border-radius: 8px;
          background: #000;
          color: #fff;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
        }
        .offBtn{
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2px 8px;
          border-radius: 8px;
          background: #000;
          color: #fff;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
        }
      }
    }
    .btnNewLine{
      display: flex;
      // width: 427px;
      // height: 60px;
      padding: 6px;
      align-items: flex-start;
      gap: 12px;
      border-radius: 8px;
      border: 1px solid #00000033;
      background: #fff;
      .leftBtn{
          // width: 227px;
          white-space: nowrap;
          cursor: pointer;
          display: flex;
          padding: 4px 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex: 1 0 0;
          align-self: stretch;
          border-radius: 6px;
          background: #fff;
          color: #757575;
          text-align: center;
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height: 1.2; /* 120% */
          .leftBtnText{
              font-family: PingFang SC !important;
          }
          .offBtn{
              display: flex;
              padding: 2px 8px;
              justify-content: center;
              align-items: center;
              gap: 8px;
              border-radius: var(--8, 8px);
              background: #000;
              color: #fff;
              text-align: center;
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: 20px;  
              font-family: PingFang SC !important;
          }
      }
      .rightBtn{
          white-space: nowrap;
          cursor: pointer;
          display: flex;
          padding: 4px 12px;
          justify-content: center;
          align-items: center;
          gap: 4px;
          flex: 1 0 0;
          align-self: stretch;
          border-radius: 6px;
          background: #fff;
          color: #757575;
          text-align: center;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 1.2; /* 120% */
          font-family: PingFang SC !important;
      }
    }
  }
  .formNewBox{
    width: 100%;
    display: flex;
   justify-content: space-between;
   gap: 6px;
   align-items: flex-end;
    .formItem{
      cursor: pointer;
      position: relative;
      flex: 1;
      width: 19%;
      border: 2px solid #00000033;
      background: #fff;
      border-radius: 8px;
      padding:24px 12px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      // transition: all 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
      .popularBlock{
        text-align: center;
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top:-3px;
        .popularText{
          display: inline-block;
          background: #FEAE00;
          padding: 4px 8px;
          border-radius: 8px;
          color: #1c180d;
          font-size: 12px;
          text-transform: uppercase;
          font-weight: 900;
          left: 50%;
          transform: translate(0, -50%);
        }
      }
      .firstItem{
        display: flex;
        flex-direction: column;
        .titleblock{
          width: 100%;
          position: relative;
          .titleText{
            text-transform: uppercase;
            font-weight: 900;
            color: #FEAE00;
            font-size: 14px;
          }
          .bestText{
            position: absolute;
            right: 0;
            bottom: 2px;
            display: inline-block;
            color: #1c180d;
            text-transform: uppercase;
            font-weight: 900;
            font-size: 10px;
            padding: 2px 4px;
            border-radius: 6px;
            background: #f9bc0633;
          }
          .bestOfActive{
            background: #FEAE00;
          }
        }
        .amountText{
          margin-top: 12px;
          font-size: 30px;
          font-weight: 900;
          letter-spacing: -0.025em;
          color: #1c180d;
        }
        .unitText{
          font-size: 11px;
        }
        .freeBlock{
          .freeText{
              font-weight: 500;
              font-size: 13px;
              color: #1c180d99;
              line-height: 1.4;
          }
          .freeAmountText{
            text-decoration-line: line-through;
            font-weight: 500;
            font-size: 14px;
            color: #1c180d99;
            line-height: 1.4;
          }
        }
      }
      .twoItem{
        .oneInfro{
          font-weight: 700;
          color: #1c180d;
          font-size: 12px;
          line-height: 1.4;
        }
        .twoInfor{
          font-weight: normal;
          color: #1c180d;
          font-size: 12px;
          line-height: 1.4;
        }
      }
      .threeItem{
        font-weight: 700;
        font-size: 12px;
        color: #16a34a;
      }
      .fourItem{
        margin: 12px 0;
        cursor: pointer;
        border-radius: 8px;
        background: #FEAE00;
        display: flex;
        padding: 5px 0;
        justify-content: center;
        align-items: center;
        gap: 10px;
        color: #1c180d;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        font-family: "PingFang SC";
      }
      .fiveItem{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 8px;
        .itemLine{
          display: flex;
          align-items: flex-start;
          gap: 8px;
          .circleItem{
            font-family: element-icons !important;
            color: #22c55e !important;
            font-size: 14px;
            margin-top: 4px;
          }
          .textBlock{
            display: flex;
            gap: 4px;
            .fiveText{
              font-size: 11px;
              color: #1c180d;
                word-break: break-word; /* 在单词内换行 */
              overflow-wrap: break-word; /* 长单词换行 */
              white-space: normal; /* 允许换行 */
            }
            .toolItem{
              display: inline-flex;
              align-items: center;
            }
            .svgItem{
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }
    .formItem:hover{
      // box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
      border: 2px solid #FEAE00;
      // transform: translateY(-10px);
      box-shadow: 0 30px 60px rgba(254, 174, 0, 0.1);
    }
    .formOfActive{
      position: relative;
      gap: 18px;
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
      border: 2px solid #FEAE00;
      background: #1c180d;
      .firstItem{
        .titleblock{
          .titleText{
            color: #FEAE00;
          }
        }
        .amountText{
          font-size: 30px;
          color: #fff;
        }
        .unitText{
          font-size: 11px;
        }
        .freeBlock{
          .freeText{
              color: #e5e7eb;
          }
          .freeAmountText{
             color: #e5e7eb;
          }
        }
      }
      .twoItem{
        .oneInfro{
          color: #e5e7eb;
        }
        .twoInfor{
          color: #e5e7eb;
        }
      }
      .threeItem{
        color: #FEAE00;
      }
      .fourItem{
      }
      .fiveItem{
        .itemLine{
          .circleItem{
            color: #FEAE00 !important;
            margin-top: 0.2vw;
          }
          .textBlock{
            .fiveText{
              color: #fff;
            }
          }
        }
      }
    }
  }
  .formBox{
    width: 100%;
    display: flex;
    margin-left:-30px;
    .packageItem{
      width: 20%;
      display: flex;
      flex-direction: column;
      gap: 30px;
      padding:15px;
     
      .itemBlock{
        cursor: pointer;
        min-height: 200px;
        width: 100%;
        flex-shrink: 0;
        border-radius: 16px;
        border: 1px solid rgba(0, 0, 0, 0.20);
      
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        padding: 40px 0 ;
        .titleName{
            color: #000;
            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px; /* 110% */
        }
        .offerItem{
            position: absolute;
            right:0;
            top:-22px;
            width: 100%;
            padding-left: 30px;
            margin-bottom: -30px;
            text-align: center;
            .imgItem{
                position: relative;
                display: inline-flex;
                .offerNum{
                  width: 100%;
                  height: 100%;
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    padding-top: 5px;
                    color:#000;
                    text-align: center;
                    font-family: Arial;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                    text-transform: capitalize;
                }
                .chargSvG{
                  width: 90px;
                  height: 28px;
                }
            }
        }
        .chargeLine{
          margin-top:22px;
          position: relative;
          width:100%;
          text-align:center;
            .text1{
                color: #000;
                font-size: 24px;
                font-style: normal;
                font-weight: 400;
                line-height: normal; /* 156.25% */
            }
            .text2{
                color:#000;
                font-size: 36px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
        }
        .unitItem{
            color: #999;
            /* 正文字体 */
            font-family: Arial;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
      }
      .itemBlock:hover{
        background: #FFF;
        border: none;
        box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.10);
      }

      .titleItem{
        width: 100%;
        position: relative;
        background: #F5F5F5;
        display: flex;
        padding:  8px 0px;
        justify-content: center;
        align-items: center;
        gap: var(--4, 4px);
        color: #FEAE00;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        font-family: "PingFang SC";
        .titleBest{
          position: absolute;
          right: -45px;
          top: 45px;
          transform: rotate(90deg);
          .leftText{
            width: 120px;
            text-align: center;
            height: 30px;
            line-height: 30px;
            background: #FEAE00;
            color: #fafafa;
            font-size: 12px;
            font-family: "PingFang SC";
            font-weight: 600;
            padding: 0 10px ;
          }
          .triangle{
            position: absolute;
            right: -16px;
            top: 0;
            width: 0;
            height: 0;
            border:15px solid;
            border-color:#FEAE00 rgba(255, 0, 0, 0)  #FEAE00 #FEAE00;
          }
        }
      }

      .amountLine{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .text1{
            color: #212121;
            font-size: 18px;
            font-weight: 700;
            display: inline-block;
            margin-right: 3px;
            font-family: "PingFang SC";
          }
          .text2{
            color: #212121;
            font-size: 34px;
            font-weight: 700;
            font-family: "PingFang SC";
          }
          .text3{
            color: #9E9E9E;
            font-size: 18px;
            font-weight: 700;
            display: inline-block;
            margin: 0 3px;
            font-family: "PingFang SC";
          }
          .text4{
            display: inline-block;
            position: relative;
            color: #9E9E9E;
            font-size: 24px;
            font-weight: 700;
            font-family: "PingFang SC";

          }
          .monthItem{
            text-align: center;
            color: #9E9E9E;
            font-size: 16px;
            font-family: "PingFang SC";
          }
      }
      .perLine{
        padding-right: 10px ;
        box-sizing: border-box;
        .perItem{
          display: flex;
          align-items: center;
          .left{
            width: 47%;
            text-align: center;
            color:#212121;
            font-size: 22px;
            font-weight: 700;
            font-family: "PingFang SC";

            .leftText1{
              font-size: 16px;
              font-family: "PingFang SC";
            }
            .leftText2{
              font-family: "PingFang SC";
            }
          }
          .center{
            flex: 1 1;
            text-align: center;
          }
          .right{
            width: 47%;
            text-align: center;
            color:#FEAE00;
            font-size: 22px;
            font-weight: 700;
            font-family: "PingFang SC";
          }
        }
        .textItem{
          display: flex;
          justify-content: space-between;
          .text1{
            width: 49%;
            word-break: keep-all;
            color: var(--Grey-Grey-600, #757575);
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            font-family: "PingFang SC";
          }
        }
      }

      .cardLine{
        margin-top: 20px;
        border-radius: 4px;
        background: #F5F5F5;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 12px 16px 22px ;
        .imgBlock{
          // margin-bottom: 16px;
          .imgItem{
            width: 80px;
            height: auto;
          }
        }
        
        .text1{
          color: #212121;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          word-break: keep-all;

        }
        .text2{
          word-break: keep-all;
          color: #212121;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: normal;
          line-height: normal;
        }
      }
      .subscribeLine{
        cursor: pointer;
        border-radius: 8px;
        background: #FEAE00;
        display: flex;
        // height: 40px;
        padding: 5px 16px;
        justify-content: center;
        align-items: center;
        gap: 10px;

        color:#212121;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; 
        font-family: "PingFang SC";
      }
      .subscribeLine:hover{
        background: #FFC23D;
      }
      .subscribeLine:active{
        background: #FEAE00;

      }
      .chooseBlock{
        display: flex;
        flex-direction: column;
        gap: 20px;
        .chooseItem{
          display: flex;
          gap: 6px;
          .chooseLeft{
            padding-top: 2px;
            .checkIcon{
              color: #FEAE00;
              font-size: 16px;
            }
            .closeicon{
              color: #9E9E9E;
              font-size: 16px;
            }
          }
          .chooseRight{
            flex: 1 1;
            font-family: "PingFang SC";
            font-size: 14px;
            word-break: keep-all;
          }
        }
      }
    }
  }
  .chargTool{
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .payLine{
      width: 100%;
      padding: 0  ; 
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      align-items: center;
      justify-content: center;
      // flex-wrap: wrap;
      .payItem{
          display: flex;
          align-items: center;
          gap: 4px;
          .payIcon{
              width: 20px;
              height: auto;
              border-radius: 2px;
          }
          .payText{
              color: #212121;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              font-family: PingFang SC !important;
          }
          .toolIcon{
            width: auto;
             height: 46px;
          }
      }
  }
  .textLine{
      width: 100%;
      text-align: center;
      padding: 0 !important;
      .textItem{
          color: #212121;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 25px; /* 178.571% */
          font-family: PingFang SC !important;
      }
  }
  .lastSubLin{
    display: flex;
    gap: 12px;
    .subBtn{
        font-family: PingFang SC;
        cursor: pointer;
        display: flex;
        box-sizing: border-box;
        padding: 5px 16px;
        // width: 80px;
        justify-content: center;
        align-items: center;
        border-radius: var(--8, 8px);
        background:  #FEAE00 !important;
        color:  #212121 !important;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .subBtn:hover{
        background: #f69f04;
    }
    .subBtn:active{
        background: #f69f04;
    }
    .defBtn{
      font-family: PingFang SC;
        cursor: pointer;
        display: flex;
        box-sizing: border-box;
        border: 1px solid #000;
        padding: 5px 16px;
        // width: 80px;
        justify-content: center;
        align-items: center;
        border-radius: var(--8, 8px);
        background:  #fff;
        color:  #000;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    // .defBtn:hover{
    //     background: #DCDCDC;
    // }
    // .defBtn:active{
    //     background: #EEE;
    // }
  }
  .wrapper{
      touch-action: pan-y !important;  //不能上下滑动的问题
  }
}
@media screen and (min-width: 767px) and (max-width: 1200px){
  .chartFormNewRoot{
      gap: 4.8vw;
    .btnNewLine{
        // height:5.6vw;
        padding:0.3vw;
        gap:0.3vw;
        .leftBtn{
            border-radius:1.4vw;
            padding:0.2vw 0.6vw;
            font-size: 1.8vw;
            gap:1vw;
            line-height: 2;
            .offBtn{
                padding: 0.2vw 0.6vw;
                gap: 0.6vw;
                font-size: 1vw;
                line-height: 2;
            }
        }
        .rightBtn{
            border-radius:1.4vw;
            padding:0.2vw 0.6vw;
            font-size: 1.8vw;
            gap:1vw;
            line-height: 2;
        }
    }
    .btnBlock{
      gap: 1.6vw;
    }
    .changeBlock{
      .changeLine{
        gap: 3vw;
        .changeBtn{
          padding-bottom: 1.2vw;
          font-size: 2vw;
          gap: 0.4vw;
          .offItem{
            padding: 0.2vw 0.8vw;
            font-size: 1.2vw;
            line-height: 2;
          }
          .offBtn{
            padding: 0.2vw 0.8vw;
            font-size: 1.2vw;
            line-height: 2;
          }
        }
      }
      .btnNewLine{
        padding: 0.4vw;
        gap: 0.6vw;
        .leftBtn{
            padding: 0.4vw 1.2vw;
            gap: 1vw;
            font-size: 1.8vw;
            .leftBtnText{
            }
            .offBtn{
                display: flex;
                padding: 0.2vw 0.8vw;
                gap: 0.8vw;
                font-size: 1.2vw;
                line-height: 2;  
            }
        }
        .rightBtn{
            padding: 0.4vw 1.2vw;
            gap: 0.4vw;
            font-size: 1.8vw;
            line-height: 1.2; /* 120% */
        }
      }
    }
    .formNewBox{
      gap: 0.8vw;
      .formItem{
        padding:1.6vw 0.8vw;
        gap: 1.2vw;
        .popularBlock{
          .popularText{
            padding: 0.4vw 0.8vw;
            font-size: 1vw;;
          }
        }
        .firstItem{
          .titleblock{
            .titleText{
              font-size: 1.2vw;
            }
            .bestText{
              bottom: 0.2vw;
              font-size: 0.8vw;
              padding: 0.2vw 0.4vw;
            }
          }
          .amountText{
            font-size: 2.8vw;
            margin-top: 1.2vw;
          }
          .unitText{
          font-size: 1.2vw;
        }
          .freeBlock{
            .freeText{
                font-size: 1.2vw;
            }
            .freeAmountText{
              font-size: 1.3vw;
            }
          }
        }
        .twoItem{
          .oneInfro{
            font-size: 1.2vw;
          }
          .twoInfor{
            font-size: 1.2vw;
          }
        }
        .threeItem{
          font-size: 1.2vw;
        }
        .fourItem{
          margin: 1.2vw 0;
          border-radius: 0.8vw;
          padding: 0.5vw 0;
          gap: 1vw;
          font-size: 1.1vw;
          line-height: 2.2vw;
        }
        .fiveItem{
          gap: 0.8vw;
          .itemLine{
            gap: 0.8vw;
            .circleItem{
              font-size: 1.2vw;
              margin-top: 0.2vw;
            }
            .textBlock{
              .fiveText{
                font-size: 1vw;
              }
              
            }
          }
        }
      }
      .formOfActive{
        gap: 1.8vw;
        .firstItem{
          .titleblock{
            .titleText{
            }
          }
          .amountText{
            font-size: 2.8vw;
          }
          .unitText{
          font-size: 1.2vw;
        }
        }
      }
    }
    .formBox{
      .packageItem{
        width: 20%;
        gap: 3vw;
        .itemBlock{
          cursor: pointer;
          min-height: 200px;
          width: 100%;
          border-radius: 16px;
          border: 1px solid rgba(0, 0, 0, 0.20);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2vw;
          padding: 4vw 0 ;
          .titleName{
              color: #000;
              text-align: center;
              font-size: 1.2vw;
              font-style: normal;
              font-weight: 400;
              line-height: 2.2vw; /* 110% */
          }
          .offerItem{
              top:-2.2vw;
              width: 100%;
              padding-left: 2vw;
              margin-bottom: -3vw;
              text-align: center;
              .imgItem{
                  position: relative;
                  .offerNum{
                      position: absolute;
                      width: 100%;
                      text-align: center;
                      padding-top: 0.3vw;
                      color:#000;
                      text-align: center;
                      font-family: Arial;
                      font-size: 1.2vw;
                      font-style: normal;
                      font-weight: 700;
                      line-height: normal;
                      text-transform: capitalize;
                  }
                  .chargSvG{
                    width: 8.5vw !important;
                    height: 2.2vw !important;
                  }
              }
          }
          .chargeLine{
            margin-top:2.2vw;
              .text1{
                  color: #000;
                  font-size: 2vw;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal; /* 156.25% */
              }
              .text2{
                  color:#000;
                  font-size: 3.2vw;
                  font-style: normal;
                  font-weight: 700;
                  line-height: normal;
              }
          }
          .unitItem{
              color: #999;
              /* 正文字体 */
              font-family: Arial;
              font-size: 1.4vw;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
          }
        }
        .titleItem{
          padding:  1vw 0;
          gap:0.4vw;
          font-size: 1.6vw;
          .titleBest{
            right: -3.9vw;
            top: 3.2vw;
            transform: rotate(90deg);
            .leftText{
              width: 10.4vw;
              height: 2.4vw;
              line-height: 2.4vw;
              font-size: 1.2vw;
              padding: 0 1vw ;
            }
            .triangle{
              right: -1.3vw;
              top: 0;
              width: 0;
              height: 0;
              border:1.2vw solid;
              border-color:#FEAE00 rgba(255, 0, 0, 0)  #FEAE00 #FEAE00;

            }
          }
        }

        .amountLine{
            .text1{
              font-size: 1.2vw;
            }
            .text2{
              font-size: 2.6vw;
            }
            .text3{
              font-size: 1.2vw;
            }
            .text4{
              font-size: 1.6vw;
            }
            .monthItem{
              font-size: 1.2vw;
            }
        }
        .perLine{
          padding-right: 1vw ;
          .perItem{
            .left{
              width: 47%;
              font-size: 1.8vw;
              .leftText1{
                font-size: 1.4vw;
              }
            }
            .right{
              font-size: 1.8vw;
            }
          }
          .textItem{
            .text1{
              font-size: 1vw;
            }
          }
        }

        .cardLine{
          margin-top: 2vw;
          border-radius: 0.4vw;
          padding: 1.4vw 1.4vw 2vw ;
          .imgBlock{
            // margin-bottom: 1.6vw;
            .imgItem{
              width: 7vw;
            }
          }
          
          .text1{
            font-size: 1.1vw;
          }
          .text2{
            font-size: 1.1vw;
          }
        }
        .subscribeLine{
          border-radius: 0.8vw;
          // height: 4vw;
          padding: 0.5vw 1.6vw;
          gap: 1vw;

          font-size: 1.4vw;
          line-height: 2.2vw; 
        }
        .chooseBlock{
          gap: 2vw;
          .chooseItem{
            gap: 0.6vw;
            .chooseLeft{
              padding-top: 0.2vw;
              .checkIcon{
                font-size: 1.2vw;
              }
              .closeicon{
                font-size: 1.2vw;
              }
            }
            .chooseRight{
              font-size: 1.1vw;
              word-break: keep-all;
            }
          }
        }
      }
    }
    .chargTool{
      gap: 2vw;
    }
    .payLine{
        padding: 0 5vw ; 
        gap: 1.6vw;
        flex-wrap: wrap;
        justify-content: center;
        .payItem{
            gap: 1vw;
            .payIcon{
                width: 2vw;
            }
            .payText{
                font-size: 1.4vw;
            }
            .toolIcon{
              width: auto;
              height: 3.5vw;
          }
        }
    }
    .textLine{
        padding: 0  5vw;
        .textItem{
            font-size: 1.4vw;
            line-height: 2; 
        }
    }
    .lastSubLin{
      display: flex;
      gap: 1.2vw;
      .subBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          padding: 0.5vw 1.6vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          // background:  #000;
          // color:  #fff;
          text-align: center;
          font-size: 1.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 2vw;
      }
      .defBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          border: 1px solid #000;
          padding:0.5vw 1.6vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          background:  #fff;
          color:  #000;
          text-align: center;
          font-size: 1.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 2vw;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .chartFormNewRoot{
    gap: 6vw;
    .btnNewLine{
        // height:7vw;
        padding:0.3vw ;
        gap:0.3vw;
        // width: 90%;
        box-sizing: border-box;
        .leftBtn{
            padding:1vw 2vw 1vw 3vw;
            font-size: 3vw;
            gap:1vw;
            line-height: 2;
            border-radius:2vw;
            .offBtn{
                padding: 0.6vw 0.8vw;
                gap: 0.6vw;
                font-size: 2vw;
                line-height: 1.4;
            }
        }
        .rightBtn{
            border-radius:2vw;
            padding:1vw 3vw;
            font-size: 3vw;
            gap:1vw;
            line-height: 2;
        }
    }
    .btnBlock{
      gap: 3vw;
    }
    .changeBlock{
      .changeLine{
        gap: 5vw;
        .changeBtn{
          padding-bottom: 2vw;
          font-size: 2.8vw;
          gap: 0.4vw;
          .offItem{
            padding: 0.2vw 0.8vw;
            font-size: 2vw;
            line-height: 2;
          }
          .offBtn{
            padding: 0.2vw 0.8vw;
            font-size: 2vw;
            line-height: 2;
          }
        }
      }
      .btnNewLine{
        padding: 0.6vw;
        gap: 0.6vw;
        .leftBtn{
            padding: 1vw 2vw;
            gap: 1vw;
            font-size:2.4vw;
            .leftBtnText{
            }
            .offBtn{
                display: flex;
                padding: 0.2vw 0.8vw;
                gap: 0.8vw;
                font-size: 2vw;
                line-height: 2;  
            }
        }
        .rightBtn{
            padding: 1vw 2vw;
            gap: 1vw;
            font-size: 2.4vw;
            line-height: 1.2; /* 120% */
        }
      }
    }
    .formNewBox{
      gap: 1.6vw;
      .formItem{
        padding:1.6vw 1vw;
        gap: 1.2vw;
        .popularBlock{
          // top: -3.8vw;
          top:-1.6vw;
          .popularText{
            padding: 0.6vw 1vw;
            font-size: 1.6vw;;
          }
        }
        .firstItem{
          .titleblock{
            .titleText{
              font-size: 2.2vw;
            }
            .bestText{
              bottom: 1vw;
              font-size: 1.2vw;
              padding: 0.4vw 0.6vw;
            }
          }
          .amountText{
            font-size: 2.8vw;
            margin-top: 1.2vw;
          }
          .unitText{
          font-size: 1.2vw;
        }
          .freeBlock{
            .freeText{
                font-size: 1.6vw;
            }
            .freeAmountText{
              font-size: 1.8vw;
            }
          }
        }
        .twoItem{
          .oneInfro{
            font-size: 1.6vw;
          }
          .twoInfor{
            font-size: 1.6vw;
          }
        }
        .threeItem{
          font-size: 1.6vw;
        }
        .fourItem{
          margin: 1.2vw 0;
          border-radius: 0.6vw;
          padding: 0.8vw 0;
          gap: 1vw;
          font-size: 1.4vw;
          line-height: 2;
        }
        .fiveItem{
          gap: 1vw;
          .itemLine{
            gap: 1vw;
            .circleItem{
              font-size: 10px;
              margin-top: 0.2vw;
            }
            .textBlock{
              .fiveText{
                font-size: 1.2vw;
              }
              .svgItem{
                width: 8px;
                height: 8px;
              }
            }
          }
        }
      }
      .formOfActive{
        gap: 1.8vw;
        .firstItem{
          .titleblock{
            .titleText{
            }
          }
          .amountText{
            font-size: 2.8vw;
          }
          .unitText{
          font-size: 1.2vw;
        }
        }
      }
    }
    .formBox{
      margin-left: -3vw;
        .packageItem{
          width: 20%;
          padding:1vw;
          gap: 3vw;
          .itemBlock{
            cursor: pointer;
            min-height: 10px;
            width: 100%;
            border-radius: 2vw;
            border: 1px solid rgba(0, 0, 0, 0.20);
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2vw;
            padding: 4vw 0 ;
            .titleName{
                color: #000;
                text-align: center;
                font-size: 1.5vw;
                font-style: normal;
                font-weight: 400;
                line-height: 2.2vw; /* 110% */
            }
            .offerItem{
                top:-3.2vw;
                width: 100%;
                padding-left: 2vw;
                margin-bottom: -3vw;
                text-align: center;
                .imgItem{
                    position: relative;
                    .offerNum{
                        position: absolute;
                        width: 100%;
                        text-align: center;
                        padding-top: 0.15vw;
                        color:#000;
                        text-align: center;
                        font-family: Arial;
                        font-size: 1.3vw;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                        text-transform: capitalize;
                    }
                    .chargSvG{
                      width: 9vw !important;
                      height: 2.2vw !important;
                    }
                }
            }
            .chargeLine{
              margin-top:3.2vw;
                .text1{
                    color: #000;
                    font-size: 2vw;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal; /* 156.25% */
                }
                .text2{
                    color:#000;
                    font-size: 3.2vw;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                }
            }
            .unitItem{
                color: #999;
                /* 正文字体 */
                font-family: Arial;
                font-size: 1.4vw;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
          }
          .titleItem{
            padding:  1vw 0;
            gap:0.4vw;
            font-size: 1.6vw;
            .titleBest{
              right: -3.9vw;
              top: 3.2vw;
              transform: rotate(90deg);
              .leftText{
                width: 10.4vw;
                height: 2.4vw;
                line-height: 2.4vw;
                font-size: 1.2vw;
                padding: 0 1vw ;
              }
              .triangle{
                right: -1.3vw;
                top: 0;
                width: 0;
                height: 0;
                border:1.2vw solid;
                border-color:#FEAE00 rgba(255, 0, 0, 0)  #FEAE00 #FEAE00;

              }
            }
          }

          .amountLine{
              .text1{
                font-size: 1.2vw;
              }
              .text2{
                font-size: 2.6vw;
              }
              .text3{
                font-size: 1.2vw;
              }
              .text4{
                font-size: 1.6vw;
              }
              .monthItem{
                font-size: 1.2vw;
              }
          }
          .perLine{
            padding-right: 1vw ;
            .perItem{
              .left{
                width: 47%;
                font-size: 1.8vw;
                .leftText1{
                  font-size: 1.4vw;
                }
              }
              .right{
                font-size: 1.8vw;
              }
            }
            .textItem{
              .text1{
                font-size: 1vw;
              }
            }
          }

          .cardLine{
            margin-top: 2vw;
            border-radius: 0.4vw;
            padding: 1.4vw 1.4vw 2vw ;
            .imgBlock{
              // margin-bottom: 1.6vw;
              .imgItem{
                width: 7vw;
              }
            }
            
            .text1{
              font-size: 1.1vw;
            }
            .text2{
              font-size: 1.1vw;
            }
          }
          .subscribeLine{
            border-radius: 0.6vw;
            // height: 4vw;
            padding: 0.8vw 2.4vw;
            gap: 1vw;

            font-size: 1.2vw;
            line-height: 2; 
          }
          .chooseBlock{
            gap: 2vw;
            .chooseItem{
              gap: 0.6vw;
              .chooseLeft{
                padding-top: 0.2vw;
                .checkIcon{
                  font-size: 1.2vw;
                }
                .closeicon{
                  font-size: 1.2vw;
                }
              }
              .chooseRight{
                font-size: 1.1vw;
                word-break: keep-all;
              }
            }
          }
        }
      }
    .chargTool{
      gap: 4vw;
    }
      .payLine{
        padding: 0 4vw 0 10vw;
        gap: 1.2vw;
        .payItem{
            gap: 0.4vw;
            .payIcon{
                width: 2vw;
                height: auto;
            }
            .payText{
                font-size: 1.4vw;
            }
            .toolIcon{
              width: auto;
              height: 6vw;
            }
        }
    }
    .textLine{
        .textItem{
            font-size: 1.4vw;
            line-height: 1.6; /* 178.571% */
        }
    }
    .lastSubLin{
      display: flex;
      gap: 1.2vw;
      .subBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          padding: 1.4vw 2vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          // background:  #000;
          // color:  #fff;
          text-align: center;
          font-size: 3.4vw;
          font-style: normal;
          font-weight: 400;
          line-height:1.4;
      }
      .defBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          border: 1px solid #000;
          padding:1.4vw 2vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          background:  #fff;
          color:  #000;
          text-align: center;
          font-size: 3.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.4vw;
      }
    }
  }
}
</style>